import "core-js/modules/web.dom-collections.iterator.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "builtin-role-permission"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("配置菜单");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存");

import { nextTick, onMounted, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { getBuiltinRoleList, getBuiltinRoleMenuTree, saveBuiltinRoleMenu } from '@/request';
export default {
  name: 'BuiltinRolePermission',

  setup(__props) {
    const loading = ref(false);
    const roleList = ref([]);
    const showModal = ref(false);
    const currentRole = ref(null);
    const menuTree = ref([]);
    const treeRef = ref();
    onMounted(() => {
      loadRoles();
    });

    function loadRoles() {
      loading.value = true;
      getBuiltinRoleList().then(res => {
        const list = res === null || res === void 0 ? void 0 : res.data;
        roleList.value = Array.isArray(list) ? list : [];
      }).finally(() => {
        loading.value = false;
      });
    }

    function openConfig(row) {
      currentRole.value = row;
      showModal.value = true;
      menuTree.value = [];
      getBuiltinRoleMenuTree({
        roleId: row.roleId
      }).then(res => {
        const data = (res === null || res === void 0 ? void 0 : res.data) || {};
        menuTree.value = Array.isArray(data.tree) ? data.tree : [];
        nextTick(() => {
          var _treeRef$value;

          (_treeRef$value = treeRef.value) === null || _treeRef$value === void 0 ? void 0 : _treeRef$value.setCheckedKeys(Array.isArray(data.checkedIds) ? data.checkedIds : []);
        });
      });
    }

    function save() {
      var _treeRef$value2, _treeRef$value3;

      if (!currentRole.value) return;
      const resourceIds = [...(((_treeRef$value2 = treeRef.value) === null || _treeRef$value2 === void 0 ? void 0 : _treeRef$value2.getCheckedKeys()) || []), ...(((_treeRef$value3 = treeRef.value) === null || _treeRef$value3 === void 0 ? void 0 : _treeRef$value3.getHalfCheckedKeys()) || [])];
      saveBuiltinRoleMenu({
        roleId: currentRole.value.roleId,
        resourceIds,
        __repeat: true,
        __warn: true
      }).then(() => {
        ElMessage.success('保存成功');
        showModal.value = false;
        loadRoles();
      });
    }

    return (_ctx, _cache) => {
      var _currentRole$value;

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: roleList.value,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "roleName",
          label: "角色名称",
          "min-width": "120"
        }), _createVNode(_component_el_table_column, {
          prop: "roleDesc",
          label: "说明",
          "min-width": "180"
        }), _createVNode(_component_el_table_column, {
          prop: "roleId",
          label: "角色ID",
          width: "100"
        }), _createVNode(_component_el_table_column, {
          prop: "menuCount",
          label: "已授权菜单数",
          width: "140"
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "140",
          fixed: "right"
        }, {
          default: _withCtx(({
            row
          }) => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: $event => openConfig(row)
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_el_dialog, {
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showModal.value = $event),
        title: `配置菜单权限 - ${((_currentRole$value = currentRole.value) === null || _currentRole$value === void 0 ? void 0 : _currentRole$value.roleName) || ''}`,
        width: "640px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => showModal.value = false)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        default: _withCtx(() => [!menuTree.value.length ? (_openBlock(), _createBlock(_component_el_alert, {
          key: 0,
          type: "warning",
          closable: false,
          title: "请先在「PC菜单管理」中维护该端菜单",
          style: {
            "margin-bottom": "12px"
          }
        })) : _createCommentVNode("", true), _createVNode(_component_el_scrollbar, {
          height: "420px",
          style: {
            "border": "1px solid #ddd",
            "border-radius": "8px",
            "padding": "12px"
          }
        }, {
          default: _withCtx(() => [menuTree.value.length ? (_openBlock(), _createBlock(_component_el_tree, {
            key: 0,
            ref_key: "treeRef",
            ref: treeRef,
            data: menuTree.value,
            "show-checkbox": "",
            "node-key": "resourceId",
            props: {
              label: 'resourceName',
              children: 'children'
            },
            "default-expand-all": ""
          }, null, 8, ["data"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }

};